import { Box, Button, Stack } from '@mui/material';
import { FC } from 'react';
import Joyride, { Step, TooltipRenderProps } from 'react-joyride';

const CustomTooltip: FC<TooltipRenderProps> = ({ backProps, closeProps, continuous, index, primaryProps, skipProps, step, tooltipProps, isLastStep }) => {
  return (
    <Box sx={{
      backgroundColor: 'rgb(255, 255, 255)',
      borderRadius: '5px',
      boxSizing: 'border-box',
      color: 'rgb(51, 51, 51)',
      fontSize: '16px',
      maxWidth: '100%',
      padding: '15px',
      position: 'relative',
      width: '380px',
    }} {...tooltipProps}>
      <Box className="tooltip__content">{step.content}</Box>
      <Stack direction="row" justifyContent="space-between">
        { !isLastStep && <Button {...skipProps}>
          {skipProps.title}
        </Button>
        }
        <Stack direction="row" justifyContent="flex-end" sx={{ marginLeft: 'auto' }}>
          {index > 0 && (
            <Button {...backProps}>
              {step.locale.back}
            </Button>
          )}
          {continuous && (
            <Button variant="contained" color="success" {...primaryProps}>
              {step.locale.next}
            </Button>
          )}
        </Stack>
      </Stack>
    </Box>
  );
}


export const Tutorial: FC<{ isRunning: boolean; steps: Step[] }> = ({ isRunning, steps }) => {
  return (
    <Joyride
      continuous
      hideCloseButton
      run={isRunning} // ツアーを始める時にtrueにする
      tooltipComponent={CustomTooltip}
      disableScrolling={true}
      // scrollToFirstStep
      showProgress // 1/2などの数が表示される
      showSkipButton
      steps={steps}
      spotlightClicks
      styles={{
        options: {
          zIndex: 10000,
        },
      }}
      callback={(data) => {
        if (data.action === 'reset') {
          localStorage.setItem('tutorialStatus', 'finished');
          window.dispatchEvent(new Event("tutorial-end"));
        }
      }}
    />
  )
}